import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { HotelService } from '../services/hotel.service';
import { Hotel } from '../hotel';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import { Http, RequestOptions, Headers, ResponseContentType } from '@angular/http';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-serchreport',
  templateUrl: './serchreport.component.html',
  styleUrls: ['./serchreport.component.css']
})
export class SerchreportComponent implements OnInit {
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild('print') print: ElementRef

  constructor(private messageService: MessageService,
      private ref:ChangeDetectorRef ,private activatedroute: ActivatedRoute,private http: Http, private hotelService: HotelService) { }
  obj: any;
  model = new Hotel;
  hotel: any;
  total: any = 0;
  totalPending: any = 0;
  totalPaid: any = 0;
  discount: any = 0;
  ngOnInit() {

    let from = this.activatedroute.snapshot.params['from'];
    let to = this.activatedroute.snapshot.params['to'];
    let hotelid = this.activatedroute.snapshot.params['hotelid'];
    this.obj = {
      fromdate: from,
      todate: to,
      hotelid: hotelid
    }
    
    this.hotelService
      .getSearchHotelList(this.obj)
      .subscribe(response => {
       
        this.hotel = response
        this.hotel.forEach(element => {
          this.totalPending += parseFloat(element.pending_amount);
          this.totalPaid += parseFloat(element.paid_amount);
          this.total += parseFloat(element.total_payment);
          this.discount += parseFloat(element.discount);
        });
        this.totalPending.toFixed(2);this.totalPaid.toFixed(2);this.total.toFixed(2);this.discount.toFixed(2);
        this.dtTrigger.next();
      })
      
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  dsbl: any;
  formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

  prints() {
    $('.act').css('display', 'none')
    $('.table').css('width', '100%')
    
    this.dsbl = true;
    setTimeout(() => {
      this.dsbl = false;
    }, 5000);
    
    let server;
    if (location.hostname != "localhost") {
      server = "http://" + location.hostname + "/tejashreecode/index.php/hotel/";
    }
    else {
      server = "http://" + location.hostname + "/tejashree/tejashreecode/index.php/hotel/";
    }

    let headers = new Headers({ 'Content-Type': 'application/json' });
    headers.append('Accept', 'application/json');
    let options = new RequestOptions({ headers: headers });

    //let options = new RequestOptions({ headers: head });       
    
    return this.http.post(server + "pdf_report",this.obj,{responseType: ResponseContentType.Blob}).map(res => {
    // return this.http.post(server + "pdf_bill", {responseType: ResponseContentType.Blob}).map(res => {
      return {
        filename: "Report.pdf",
        data: res.blob()
      };
    })
    .subscribe(res => {
      // debugger;
        console.log('start download:',res);
        let url = window.URL.createObjectURL(res.data);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }, error => {
        console.log('download error:', JSON.stringify(error));
      }, () => {
        console.log('Completed file download.');
        //$('.act').css('display', 'block')
        //location.reload();
      });

  }


  paybill(bill_no) {
    $(".pay_" + bill_no).hide();
    $(".paypartial_" + bill_no).hide();
    $(".delete_" + bill_no).hide();

    this.hotelService.addpayBillDirect({ bill_no: bill_no }).subscribe(
      response => {
        if (response.icon == "ok") {
          $(".pending_" + bill_no)
            .removeClass("badge-error")
            .addClass("badge-success")
            .html("Paid");
        } else {
            $(".pay_" + bill_no).show();
            $(".paypartial_" + bill_no).show();
            $(".delete_" + bill_no).show();
        }
        this.messageService.showMessage(
          "div#msg",
          "alert-" + response.bg,
          response.response,
          "glyphicon-" + response.icon
        );
      },
      err => {
        console.log("Json Response Error");
      }
    );
    this.ref.markForCheck();
  }

  data
  deleteBill(billNo: string) {
    if (confirm("Are you sure to delete bill")) {
      this.data = { "bill_no": billNo }
      this.hotelService
        .deleteBill(this.data)
        .subscribe(response => {
          this.totalPending = 0;
          this.totalPaid = 0;
          this.total = 0;
          this.discount = 0;

          $("#print").DataTable().destroy();
          this.hotelService
            .getSearchHotelList(this.obj)
            .subscribe(response => {
              this.hotel = response
              this.hotel.forEach(element => {
                this.totalPending += parseFloat(element.pending_amount);
                this.totalPaid += parseFloat(element.paid_amount);
                this.total += parseFloat(element.total_payment);
                this.discount += parseFloat(element.discount);
              });
              this.dtTrigger.next();
            })
        });
    }
  }
}




// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/serchreport/serchreport.component.ts